import { render, staticRenderFns } from "./MemberOtoCommunication.vue?vue&type=template&id=ccebbdc0&scoped=true&"
import script from "./MemberOtoCommunication.vue?vue&type=script&lang=js&"
export * from "./MemberOtoCommunication.vue?vue&type=script&lang=js&"
import style0 from "./MemberOtoCommunication.vue?vue&type=style&index=0&id=ccebbdc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccebbdc0",
  null
  
)

export default component.exports